export class Progress {
  progressId
  isCurrent
  order
  isDefault
  icon
  name
  description

  constructor(progress = {}) {
    this.progressId = progress.progressId ? String(progress.progressId) : ''
    this.isCurrent = progress.isCurrent ? Boolean(progress.isCurrent) : false
    this.order = progress.order ? Number(progress.order) : 0
    this.isDefault = progress.isDefault ? Boolean(progress.isDefault) : false
    this.icon = progress.icon ? String(progress.icon) : ''
    this.name = progress.name ? String(progress.name) : ''
    this.description = progress.description ? String(progress.description) : ''
  }
}